import { Link } from '@tanstack/react-router';
import { isLeadCarryingRole } from 'cpool-utils';

import Logo from '~/assets/CPOOL-Logo.svg?url';
import useUserInfo from '~/hooks/useUserInfo';

const NavLogo = () => {
    const user = useUserInfo();
    if (!user) return null;
    const link = isLeadCarryingRole(user.role) ? '/dashboard' : '/management';

    return (
        <Link
            to={link}
            className="inline-block mr-3 text-lg font-bold md:text-2xl text-blue-dark whitespace-nowrap md:mr-5"
        >
            <img src={Logo} alt="CPOOL Logo" className="w-24 h-10 min-w-24" />
        </Link>
    );
};

export default NavLogo;
